import {
  LOG_IN_URL,
  USER,
} from 'constants/apiUrls';
import { post, get, patch } from 'utils/requests';

export const logInApi = data => post(LOG_IN_URL, data);
export const userDetailsApi = data => get(USER, data);
export const updateUserDetailsApi = data => patch(USER, data);
